import React from 'react';

const HeadingH2 = (props) => {

    const { size, weight, color } = props;

    let className= '';
    className += 'u-fontSize' + size;
    className += ' u-fontWeight' + weight;
    className += ' u-textColor' + color;

    return (
        <h2 className={className}>{props.children}</h2>
    );
}

export default HeadingH2;


// WEBPACK FOOTER //
// ./src/components/UI/Headings/HeadingH2/HeadingH2.js